import moment from 'moment';
import DateTimesUtils from "core/utils/DateTimesUtils";
import {ScheduleEventModel} from "site-apps/distribution/schedules/ScheduleModels";

/*

# Valores que se emplearan
# week {days: []}
# month {day: 1 - 31, type: "d"} - by day of month
#     | {day: 0 - 6, value: 1 - 4, type: "n"} - by number
#     | {day: 0 - 6, value: "first | last", type: "p"} - by place
#
# year {day: 1 - 31, value: 1 - 12, type: "d"}
#    | {day: 0 - 6, value: 1 - 12, place: 0 - 4, type: "n"}
#    | {day: 0 - 6, value: 1 - 12, place: "first | last"}, type: "p"}
#
{
    id: '1',
    calendarId: '0',
    title: 'Evento rojo',
    category: 'time',
    start: `${todayString}T08:00:00`, // Comienza a media noche
    end: `${todayString}T14:00:00`,  // Finaliza al final del día
    backgroundColor: '#fb9c87', // Color de fondo del evento
},
*/


const generateEventsForRange = (items, dateRange, routesIds) => {
    const createEventIfNotExists = (item, current) => {
        item.routeslst.forEach(route => {
            let schedule = new ScheduleEventModel(item, route, current);
            if (!routesIds.includes(schedule.id)) {
                generatedEvents.push(schedule);
            }
        })
    }
    if (!items.length) return [];
    const generatedEvents = [];
    // -
    const now = moment();
    const start = dateRange.start;
    const end = dateRange.end;
    // -
    for (let current = start; current.isSameOrBefore(end); current.add(1, 'day')) {
        if (!current.isAfter(now)) continue;
        items.some(item => {
            const {is_periodic, repeat, values, date_start, date_end} = item;
            const startDate = moment(date_start);
            const endDate = date_end ? moment(date_end) : null;

            // Validate dates
            if (current.isBefore(startDate)) return false;
            if (endDate && current.isAfter(endDate)) return false;

            // Create events
            if (is_periodic) {
                switch (repeat) {
                    case "d":
                        let diff = startDate.diff(current, 'days');
                        if (diff % item.every === 0) {
                            createEventIfNotExists(item, current);
                        }
                        break;
                    case 'w': // Semanal
                        if (values.days && values.days.includes(current.day().toString())) {
                            createEventIfNotExists(item, current);
                        }
                        break;

                    case 'm': // Mensual
                        switch (values.type) {
                            case "d":
                                if (current.date() === values.day) {
                                    createEventIfNotExists(item, current);
                                }
                                break;
                            case "n":
                                if (current.day() === values.day && DateTimesUtils.dayMonthPlace(current) === values.value) {
                                    createEventIfNotExists(item, current);
                                }
                                break;
                            case "p":
                                let lastDay = DateTimesUtils.lastDayMonth(current, values.day);
                                if (current.date() === lastDay) {
                                    createEventIfNotExists(item, current);
                                }
                                break;
                            default:
                        }
                        break;

                    case 'y': // Anual
                        switch (values.type) {
                            case "d":
                                if (current.month() + 1 === values.value && current.date() === values.day) {
                                    createEventIfNotExists(item, current);
                                }
                                break;
                            case "n":
                                if (current.month() + 1 === values.value && current.day() === values.day) {
                                    let weeekday = DateTimesUtils.dayMonthPlace(current);
                                    if (weeekday === values.place) {
                                        createEventIfNotExists(item, current);
                                    }
                                }
                                break;
                            case "p":
                                if (current.month() + 1 === values.value) {
                                    let lastDay = DateTimesUtils.lastDayMonth(current, values.day);
                                    if (current.date() === lastDay) {
                                        createEventIfNotExists(item, current);
                                    }
                                }
                                break;
                            default:
                        }

                        break;

                    default:
                        console.warn("Tipo de repetición desconocida:", repeat);
                }
            }
            return false;
        });
    }
    return generatedEvents;
};

export default generateEventsForRange;
